export default __webpack_public_path__ + "static/media/WaterTower400.4edd9c95.jpg";